import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, inject, signal, viewChild } from '@angular/core';

import autocomplete from 'autocompleter';

import { Institution, InstitutionService, InstitutionType } from '../../services/institution.service';

@Component({
  selector: 'app-institution-autocomplete',
  standalone: true,
  imports: [],
  templateUrl: './institution-autocomplete.component.html',
  styleUrl: './institution-autocomplete.component.scss'
})
export class InstitutionAutocompleteComponent implements AfterViewInit {
  institutionInput = viewChild.required('institutionInput', { read: ElementRef });
  @Input() placeholder = 'Search for an institution';
  @Input() class = '';
  @Input() onlyActive = true;
  @Input() institutionType: InstitutionType = InstitutionType.all;
  @Input() excludedIids: number[] = [];
  @Output() selectInstitutionEvent = new EventEmitter<Institution>();

  private institutionService = inject(InstitutionService);

  lockInstitution = signal(false);

  ngAfterViewInit(): void {
    this.setFocus();
    autocomplete<Institution>({
      input: this.institutionInput().nativeElement,
      emptyMsg: 'No institutions found',
      minLength: 3,
      fetch: (text: string, update: (items: Institution[]) => void) => {
        const list = this.institutionService.searchInstitutions(text)
          .filter(i => (this.onlyActive ? i.active : true)
            && (this.institutionType === InstitutionType.all ? true : i.institutionType === this.institutionType)
            && (!this.excludedIids.includes(i.iid)));
        list.sort((a, b) => a.name?.localeCompare(b.name) || a.city?.localeCompare(b.city) || a.state?.localeCompare(b.state));
        update(list);
      },
      onSelect: (item: Institution) => {
        this.institutionInput().nativeElement.value = item.label;
        this.selectInstitutionEvent.emit({ institutionType: item.institutionType, iid: item.iid, name: item.name, city: item.city, state: item.state, label: item.label } as Institution);
        this.lockInstitution.set(true);
        this.institutionInput().nativeElement.blur();
      },
      render: this.institutionType == InstitutionType.all ? this.renderAll : this.render
      //render: function (item: Institution): HTMLDivElement | undefined {
      //  const itemElement = document.createElement('div');
      //  if (this.institutionType === InstitutionType.all) {
      //    if (item.institutionType === InstitutionType.bank) {
      //      itemElement.innerHTML = `<div>${item.name} (${item.city}, ${item.state})</div>`;
      //    } else {
      //      itemElement.innerHTML = `<div>${item.name} (${item.city}, ${item.state})</div>`;
      //    }
      //  }
      //  if (item.lastReportingDate != null) {
      //    itemElement.className = "closed-insitution";
      //    itemElement.innerHTML += `<div>Last filed in ${new Date(item.lastReportingDate).toLocaleDateString('en-us', { month: "short", year: "numeric" })}</div>`;
      //  }
      //  return itemElement;
      //}
    });
  }

  render(item: Institution): HTMLDivElement | undefined {
    const itemElement = document.createElement('div');
    itemElement.innerHTML = `<div>${item.name} (${item.city}, ${item.state})</div>`;
    if (item.lastReportingDate != null) {
      itemElement.className = "closed-insitution";
      itemElement.innerHTML += `<div>Last filed in ${new Date(item.lastReportingDate).toLocaleDateString('en-us', { month: "short", year: "numeric" })}</div>`;
    }
    return itemElement;
  }

  renderAll(item: Institution): HTMLDivElement | undefined {
    const itemElement = document.createElement('div');
    if (item.institutionType == InstitutionType.bank) {
      itemElement.innerHTML = `<div><svg class="icon institution_icon institution_icon--bank" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 120c0-13.3 10.7-24 24-24h92c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76H152c-13.3 0-24-10.7-24-24V256 152zm144 52c0-15.5-12.5-28-28-28H176v56h68c15.5 0 28-12.5 28-28zM176 336h84c15.5 0 28-12.5 28-28s-12.5-28-28-28H244 176v56z" /></svg> ${item.name} (${item.city}, ${item.state})</div>`;
    } else {
      itemElement.innerHTML = `<div><svg class="icon institution_icon institution_icon--cu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM167.4 199.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z" /></svg>${item.name} (${item.city}, ${item.state})</div>`;
    }
    if (item.lastReportingDate != null) {
      itemElement.className = "closed-insitution";
      itemElement.innerHTML += `<div>Last filed in ${new Date(item.lastReportingDate).toLocaleDateString('en-us', { month: "short", year: "numeric" })}</div>`;
    }
    return itemElement;
  }

  setFocus() {
    this.institutionInput().nativeElement.focus();
    this.lockInstitution.set(false);
  }

  clearInstitution() {
    this.institutionInput().nativeElement.value = '';
    this.setFocus();
  }
}
